import { useEffect, useState } from 'react';
import Modal from '../Components/Modal';
// import BiddingForm from './BiddingForm';
import axios from 'axios';
import ModalAcceptOffer from './ModalAcceptOffer';
import { getToken, windowReload } from '../utils';

function StageAcceptOffer({ content }) {
  const [isAcceptingOffer, setIsAcceptingOffer] = useState();
  const [messageDetails, setMessageDetails] = useState({});

  const { token: userToken } = getToken();
  const {
    clickedBidChatUser,
    getDataById,
    handleOpenandCloseModal,
    openModal,
    handleToast,
    isDisabled,
    setisDisabled,
    disableAccept,
    // disableBidAndAccept,
  } = content;
  // const userId = getToken()?.user.id;
  const handleAcceptOffer = () => {
    setIsAcceptingOffer(true);
  };
  //Accept offer
  useEffect(() => {
    let url;
    let data;
    if (clickedBidChatUser?.bidder_accepted === '1') {
      url = `${process.env.REACT_APP_BASE_URL}/accepted-offer/store`;
      data = {
        amount: clickedBidChatUser?.chats[0]?.amount,
        rate: clickedBidChatUser?.chats[0]?.rate,
        cx_transaction_id: getDataById?.id,
        bid_chat_id: clickedBidChatUser?.chats[0]?.id,
      };
    } else if (clickedBidChatUser?.bidder_accepted === '0') {
      url = `${process.env.REACT_APP_BASE_URL}/bid/chat-store`;
      data = {
        amount: clickedBidChatUser?.chats[0]?.amount,
        rate: clickedBidChatUser?.chats[0]?.rate,
        message: 'accepted',
        bid_id: clickedBidChatUser?.id,
      };
    }
    if (isAcceptingOffer) {
      const acceptOffer = async () => {
        try {
          const response = await axios.post(url, data, {
            headers: { Authorization: `Bearer ${userToken}` },
          });

          console.log('successfull', response.data);
          setisDisabled(true);
          handleToast('success', 'Offer accepted successfully');
          handleOpenandCloseModal('close');
          if (data.cx_transaction_id) {
            setMessageDetails({
              message: (
                <span className='flex flex-row justify-between'>
                  Offer Accepted
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='16'
                    height='16'
                    viewBox='0 0 1024 1024'
                  >
                    <path
                      fill='currentColor'
                      d='M512 64a448 448 0 1 1 0 896a448 448 0 0 1 0-896zm-55.808 536.384l-99.52-99.584a38.4 38.4 0 1 0-54.336 54.336l126.72 126.72a38.272 38.272 0 0 0 54.336 0l262.4-262.464a38.4 38.4 0 1 0-54.272-54.336L456.192 600.384z'
                    />
                  </svg>
                </span>
              ),
              color: 'text-lime-500',
            });
          }
          windowReload();
        } catch (error) {
          handleToast('error', 'Failed to accept offer, please try again!');
        } finally {
          setIsAcceptingOffer(false);
        }
      };
      acceptOffer();
    }
  }, [
    userToken,
    isAcceptingOffer,
    clickedBidChatUser?.bidder_accepted,
    clickedBidChatUser?.chats,
    clickedBidChatUser?.id,
    getDataById?.id,
    setisDisabled,
    handleToast,
    handleOpenandCloseModal,
  ]);

  useEffect(() => {
    if (!isDisabled) {
      setMessageDetails({
        message: 'Accept current offer',
        color: 'text-b-mc',
      });
    } else if (isDisabled && clickedBidChatUser?.offer_owner_accepted === '0') {
      setMessageDetails({
        message: 'Waiting for offer to be accepted',
        color: 'text-orange-500',
      });
    } else {
      setMessageDetails({
        message: (
          <span className='flex flex-row justify-between'>
            Offer Accepted
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='16'
              height='16'
              viewBox='0 0 1024 1024'
            >
              <path
                fill='currentColor'
                d='M512 64a448 448 0 1 1 0 896a448 448 0 0 1 0-896zm-55.808 536.384l-99.52-99.584a38.4 38.4 0 1 0-54.336 54.336l126.72 126.72a38.272 38.272 0 0 0 54.336 0l262.4-262.464a38.4 38.4 0 1 0-54.272-54.336L456.192 600.384z'
              />
            </svg>
          </span>
        ),
        color: 'text-lime-500',
      });
    }
  }, [clickedBidChatUser?.offer_owner_accepted, isDisabled]);

  return (
    <div className='w-full pb-4 border-hf p-4 rounded-lg relative  bg-p-wh '>
      <div
        className={`w-fit h-fit px-3 py-1 absolute -top-4 left-1/2 transform -translate-x-1/2  shadow-md rounded-full flex justify-center items-center  ${
          clickedBidChatUser?.offer_owner_accepted === '1'
            ? 'bg-b-mc text-p-wh'
            : 'bg-p-wh text-p-bk'
        }`}
      >
        2
      </div>
      <div className='flex flex-row justify-between mt-2 mb-2'>
        <h2 className='font-semibold text-sm'>Accept Offer</h2>
        <button
          className='py-1.5 bg-b-mc text-p-wh rounded text-xs h-fit w-16 disabled:bg-p-bk/5 hover:bg-b-mc/75 focus:bg-b-mc/80'
          onClick={() => handleOpenandCloseModal('acceptOffer')}
          disabled={!!disableAccept}
        >
          Accept
        </button>
      </div>

      <div className=' flex flex-col text-p-bk w-full text-xs'>
        <p className={messageDetails.color}>{messageDetails.message} </p>

        <div className='px-1 bg-b-mct border-dashed border-y-hf border-s-bk mt-2 pb-1'>
          <p className='py-1  flex flex-row justify-between w-full '>
            <span className='text-s-bk'>Amount</span>
            {clickedBidChatUser?.chats[0]?.amount
              ? Number(clickedBidChatUser?.chats[0]?.amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
              : 0}{' '}
            {getDataById?.quote_currency?.symbol}
          </p>
          <p className=' flex flex-row justify-between w-full'>
            <span className='text-s-bk'>Rate</span>
            {clickedBidChatUser?.chats[0]?.rate
              ? Number(clickedBidChatUser?.chats[0]?.rate).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
              : 0}{' '}
            {getDataById?.base_currency?.symbol}
          </p>
        </div>
      </div>

      <Modal open={openModal === 'acceptOffer'}>
        <ModalAcceptOffer
          content={{
            clickedBidChatUser,
            handleAcceptOffer,
            isAcceptingOffer,
            getDataById,
            handleOpenandCloseModal,
          }}
        />
      </Modal>
    </div>
  );
}

export default StageAcceptOffer;
